/*
 * 功能名称: 工作分派（非里程碑）
 * 创 建 人: 张敬磊
 * 日    期: 2024年7月13日10:35:30
 */
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class WorkAssignApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'work-assign';
    } 

}